module.exports = __webpack_public_path__ + "img/marina2.a72ddc79.jpg";